import GlobalUserData, { iGlobalUserData } from "@models/GlobalUserData";
import { useData } from "@hooks/useData";
import Http from "@core/fetch";

async function getGlobalUserData(): Promise<iGlobalUserData> {
    const response: Window['pageData'] = await Http.get('get global user data');
    return new GlobalUserData(response);
}

export default function useGlobalUserData() {
    return useData(new GlobalUserData(), getGlobalUserData);
}